import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';
import { ExportMsmtComponent } from './components/export-msmt/export-msmt.component';
import { AuthGuard } from './core/guards/auth.guard';
import { HelpComponent } from './modules/help/help.component';
import { LayoutComponent } from './modules/layout/layout.component';
import { PAP_MODULE_ROOT_URL } from './modules/pap/pap.module';
import { SETTINGS_MODULE_ROOT_URL } from './modules/settings/settings.module';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'signup',
    loadChildren: () => import('./modules/signup/signup.module').then((m) => m.SignupModule),
  },
  {
    path: 'teacher-signup',
    loadChildren: () => import('./modules/teacher-signup/teacher-signup.module').then((m) => m.TeacherSignupModule),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'verification',
        loadChildren: () => import('./modules/verification/verification.module').then((m) => m.VerificationModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'management/dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardRoutingModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'management/children',
        loadChildren: () => import('./modules/children/children.module').then((m) => m.ChildrenModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'management/groups',
        loadChildren: () => import('./modules/groups/groups.module').then((m) => m.GroupsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'management/attendance',
        loadChildren: () => import('./modules/evidence/evidence.module').then((m) => m.EvidenceModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'management/gradebook',
        loadChildren: () => import('./modules/gradebook/gradebook.module').then((m) => m.GradebookModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'management/announcement',
        loadChildren: () => import('./modules/announcement/announcement.module').then((m) => m.AnnouncementModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'management/export-msmt',
        component: ExportMsmtComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'settings/enrollment',
        loadChildren: () => import('./modules/enrollment/enrollment.module').then((m) => m.EnrollmentRoutingModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'children-portfolio',
        loadChildren: () => import('./modules/children-portfolio/children-portfolio.module').then((m) => m.ChildrenPortfolioModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'pap',
        loadChildren: () => import('./modules/pap/pap.module').then((m) => m.PapModule),
        canActivate: [AuthGuard],
        providers: [
          {
            provide: PAP_MODULE_ROOT_URL,
            useValue: 'pap',
          },
        ],
      },
      {
        path: 'settings',
        loadChildren: () => import('./modules/settings/settings.module').then((m) => m.SettingsModule),
        canActivate: [AuthGuard],
        providers: [
          {
            provide: SETTINGS_MODULE_ROOT_URL,
            useValue: 'settings',
          },
        ],
      },
      {
        path: 'management/help',
        component: HelpComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  { path: '**', component: NotFoundComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: !environment.production && false,
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
